import * as React from "react";
const SvgFiRrBicycleJourney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bicycle-journey_svg__a)">
      <path
        fill="#062147"
        d="M18 9V1a1 1 0 0 1 1-1c.6 0 1.195.128 1.751.377l2.813 1.259c.581.399.581 1.329 0 1.729L19.999 5.25V9A1 1 0 1 1 18 9m2 5h-7c-1.103 0-2-.897-2-2s.897-2 2-2h2a1 1 0 1 0 0-2h-2c-2.206 0-4 1.794-4 4s1.794 4 4 4h7c1.103 0 2 .897 2 2s-.897 2-2 2h-6a1 1 0 1 0 0 2h6c2.206 0 4-1.794 4-4s-1.794-4-4-4M8.5 19c-.073 0-.141.015-.213.021L7.184 17h.815a1 1 0 1 0 0-2H6.628a1.66 1.66 0 0 0-1.437.817 1.66 1.66 0 0 0-.03 1.652l.069.126-.888.533-.694-1.157A2.01 2.01 0 0 0 1.933 16H.999a1 1 0 1 0 0 2h.934l.602 1.004q-.018-.002-.036-.004a2.5 2.5 0 1 0 2.5 2.5c0-.45-.128-.867-.337-1.232l1.526-.916.341.625a2.48 2.48 0 0 0-.53 1.523 2.5 2.5 0 1 0 2.5-2.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bicycle-journey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBicycleJourney;
